export default {
  '-3': '不能绑定自己的邀请码哦',
  '-4': '已绑定其他账号，不能重复绑定',
  '-5': '不能与好友互相绑定',
  '-6': '无效邀请码，请检查后重新输入',
  '-7': '你的账号存在风险，无法绑定邀请码',
  8008: '已绑定其他账号，不能重复绑定',
};
